import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import _ from 'lodash'

import { EmailService } from '../../service/email.service';
import { EmailModel } from '../../model/email.model';

@Component({
	selector: 'app-notification-modal',
	templateUrl: './notification-modal.component.html',
	styles: ['']
})
export class NotificationModalComponent implements OnInit {
	@Input() sendUnconformityEmailOnly: boolean = false;
	@Input() sendUnconformityEmailDep: boolean = false;
	@Input() sendUnconformityEmailEst: boolean = false;
	@Input() sendCompleteEmailDep: boolean = false;
	@Input() sendCompleteEmailEst: boolean = false;
	@Input() isChecklist: boolean = false;
	@Input() closable: boolean = false;
	@Input() emails: any[] = [];

	@Output() save = new EventEmitter();

	saved: boolean;
	display: boolean;
	loadedMails: boolean;
	sourceEmails: EmailModel[] = [];
	targetEmails: EmailModel[] = [];
	sourceEmailsActionPlan: any[] = []
	targetEmailsActionPlan: any[] = []

	constructor(private emailService: EmailService) {}

	ngOnInit() {}

	onClose() {}

	onOpen() {
		if (!this.isChecklist) {
			this.buildEmails();
		} else {

			if (this.existMails())
			this.display = true;
			else this.buildEmails();

		}
	}

	existMails = () => this.sourceEmails.length > 0 || this.targetEmails.length > 0;

	cleanValues() {
		this.sourceEmails = [];
		this.targetEmails = [];
		this.sourceEmailsActionPlan = [];
		this.targetEmailsActionPlan = [];		
	}
	
	onSave() {
		this.save.emit({
			emails: [...this.targetEmails, ...this.targetEmailsActionPlan],
			sendUnconformityEmailOnly: this.sendUnconformityEmailOnly,
			sendUnconformityEmailDep: this.sendUnconformityEmailDep,
			sendUnconformityEmailEst: this.sendUnconformityEmailEst,
			sendCompleteEmailDep: this.sendCompleteEmailDep,
			sendCompleteEmailEst: this.sendCompleteEmailEst,
		});

		this.saved = true;
		this.display = false;
	}

	buildEmails() {
		this.cleanValues();
		this.loadedMails = false;

		let checklistReportMails: any[] = [];
		let checklistActionPlanMails: any[] = [];

		if (this.emails) this.emails.forEach(email => email.action_plan_only ?
		checklistActionPlanMails.push(email) : checklistReportMails.push(email));

		checklistReportMails = _.groupBy(checklistReportMails, 'email_id')
		checklistActionPlanMails = _.groupBy(checklistActionPlanMails,'email_id')

		this.emailService.getPaginated(0, 1000000, null, null).subscribe(result => {
			if (result['rows'])
				result['rows'].forEach((row: EmailModel) => {
					let rowActionPlan = {...row, action_plan_only: true};

					// set mail action plan
					if (!checklistActionPlanMails[row.id] && !this.sourceEmailsActionPlan[row.id])
					this.sourceEmailsActionPlan.push(rowActionPlan);
					else if (this.sourceEmailsActionPlan[row.id]) null;
					else this.targetEmailsActionPlan.push(rowActionPlan);

					// set mail report
					if (!checklistReportMails[row.id] && !this.sourceEmails[row.id]) 
					this.sourceEmails.push(row);
					else if (this.sourceEmails[row.id]) null;
					else this.targetEmails.push(row);		
					
					this.display = true;
					this.loadedMails = true;
				})
		})
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/notification-modal/notification-modal.component.ts